import {
  SpinnerOverlay,
  Tag,
  Timeline,
  TimeLineItem,
} from "@vesatogo/grass-core"
import classNames from "classnames"
import dayjs from "dayjs"
import { Link, useNavigate } from "react-router-dom"
import { useTradeTimeLineQuery } from "~/generated/graphql"

const PATTI_COLORS: Record<string, string> = {
  "Offer Patti": "!bg-[#ED7500]",
  order: "!bg-blue-600",
  "Production Planning": "!bg-[#E8625F]",
  "Production Final": "!bg-[#A63121]",
  storage: "!bg-brown-500",
  "Hishob Patti": "!bg-green-400",
  "Sauda Pavti": "!bg-yellow-500",
  Inward: "!bg-blue-500",
  "Booking Patti": "!bg-[#ED7500]",
}

interface PattiTimelineProps {
  tradeId: number
  isProductionTrade?: boolean
  isSidebar?: boolean
  className?: string
}

export const PattiTimeline = ({
  tradeId,
  isProductionTrade = false,
  isSidebar = false,
  className,
}: PattiTimelineProps) => {
  const navigate = useNavigate()

  const [{ data, fetching }] = useTradeTimeLineQuery({
    pause: !tradeId,
    variables: {
      ...(isProductionTrade
        ? ({ productionTradeId: tradeId } as any)
        : ({ tradeId } as any)),
    },
  })

  const timelineData = data?.trade_timeline || []
  // const storagePattiHeader = timelineData.find((item: any) =>
  //   item.title.toLowerCase().includes("storage")
  // )

  return (
    <div
      className={classNames(
        "flex flex-col gap-4",
        isSidebar ? "p-0" : "p-4",
        className
      )}
    >
      <SpinnerOverlay show={fetching} />
      {/* {storagePattiHeader && (
        <div className="text-green-700 font-500 text-base mb-2">
          Storage Patti - {storagePattiHeader.msg}
        </div>
      )} */}

      <div
        className={classNames(
          "flex-1 overflow-y-auto",
          isSidebar
            ? "bg-transparent"
            : "bg-white p-6 rounded-lg shadow-sm border border-gray-100"
        )}
      >
        {timelineData.length > 0 ? (
          <Timeline className="production-timeline">
            {timelineData.map((item: any, index: number) => {
              const id = Number(item?.msg?.replace("#", ""))
              const isCurrent = item?.is_current
              const color = PATTI_COLORS[item.title]
              return (
                <TimeLineItem
                  key={index}
                  title={
                    <div className="flex justify-between items-center w-full">
                      <span
                        className="text-gray-800 font-600 cursor-pointer"
                        onClick={() => {
                          if (isProductionTrade) {
                            navigate(`/d/production-planning/${id}`)
                          } else {
                            // Default to trade-requests for trade flow if it's a trade request page
                            // or /d/trade/ if it's the general trade page.
                            // For now, let's keep it consistent with ProductionTimeline.tsx
                            // but we might need to adjust for SideBar.tsx usage.
                            navigate(`/d/trade-requests/${id}`)
                          }
                        }}
                      >
                        {item.title}
                      </span>
                      {isCurrent && (
                        <Tag intent="info" className="!rounded-xl">
                          Current
                        </Tag>
                      )}
                    </div>
                  }
                  bulletProps={{
                    className: classNames(
                      "w-3 h-3 rounded-full bg-gray-400 absolute -left-[7px]",
                      color
                    ),
                  }}
                >
                  <div className="flex flex-col gap-1 mt-1">
                    <div className="flex items-center text-gray-500 text-sm">
                      <span>{item.msg}</span>
                      {item.date && (
                        <>
                          <span className="mx-2">•</span>
                          <span>{dayjs(item.date).format("D MMM 'YY")}</span>
                        </>
                      )}
                    </div>
                    {item.parent_trade_id && (
                      <>
                        {/* <span className="mx-2">•</span> */}
                        <Link
                          to={`/d/trade-requests/${item.parent_trade_id}`}
                          className="text-blue-600 hover:underline"
                        >
                          Parent Trade: {item.parent_trade_id}
                        </Link>
                      </>
                    )}
                  </div>
                </TimeLineItem>
              )
            })}
          </Timeline>
        ) : (
          <div className="text-center text-gray-500 py-10">
            {fetching ? "Loading timeline..." : "No timeline data found"}
          </div>
        )}
      </div>
    </div>
  )
}
